import React, { useState } from 'react';
import styled from 'styled-components';
// import { FeedbackModel } from '../feedbackModels';
import { Button, Space, Popconfirm } from 'antd';


import Card from './custom-style-componets';



import { EditIcon, RemoveIcon } from './icon-components';
const CARD_HEIGHT = '180px';
const HoveredCardWrapper = styled.div`
  position: relative;
  top: calc(-${CARD_HEIGHT} / 2);
  text-align: center;
  svg {
    width: 20px;
    height: 17px;
  }
`;



function HoveredCard(props) {
  const { history, feedback, onRemove } = props;


  return (
    <HoveredCardWrapper>
      <Space>
        <Button
          shape="circle"
          style={{ width: 50, height: 50 }}
          onClick={() => { history.push(`/manage/circle-user/${feedback.uid}`, { data: feedback }) }}
        ><EditIcon /></Button>
        <Popconfirm
          title="Are you sure delete this user?"
          onConfirm={() => { if (onRemove) { onRemove(feedback) } }}
          onCancel={() => { }}
          okText="Yes"
          cancelText="No"
        >
          <Button
            shape="circle" style={{ width: 50, height: 50 }}

          ><RemoveIcon /></Button>
        </Popconfirm>
      </Space>


    </HoveredCardWrapper >
  )
}

function CardDetail(props) {
  const { feedback } = props;
  const {
    address,
    nickname,
    email,
    imgUrl
  } = feedback;

  return (
    <div className="feedback-card">
      <div className="row">
        <div className="col-12 col-lg-4">
          <img style={{ height: 100, borderRadius: "100%", width: 100 }} src={!imgUrl ? '/assets/img/no_Image.png' : imgUrl} alt="soucrce" />
        </div>
        <div className="col-12 col-lg-8">
          <div className="feedback-card__info">
            <div className="feedback-card__info__name">{nickname}</div>
            {address ? (<div className="feedback-card__info__coquan">{address}</div>) : null}
          </div>

          <div className="feedback-card__description">
            {email}
          </div>
        </div>

      </div>
    </div>
  )
}

export function CircleCard(props) {
  const { feedback } = props;
  const [isHovered, setHovered] = useState(false);

  return (
    <Card
      isHovered={isHovered}
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onTouchMoveCapture={() => setHovered(!isHovered)}
    >
      <CardDetail  {...props} feedback={feedback} />
      {isHovered && <HoveredCard  {...props} feedback={feedback} />}
    </Card >
  );
}
